import { Tooltip as TooltipLib } from '@ui-kitten/components';

export const Tooltip = TooltipLib;
